module.exports = __webpack_public_path__ + "img/avatar6.4ea7d8a4.svg";